import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
// CSS
import "./LangTag.css";

/* Returns an ISO-tag corresponding to the language passed in parameter. */
export const LangTag: FunctionComponent<{ lang: string }> = ({ lang }) => {
    const { i18n } = useTranslation();
    const langName = new Intl.DisplayNames([i18n.language], { type: "language" });

    return <span className="langTag" aria-label={langName.of(lang)} title={langName.of(lang)}>{lang.toUpperCase()}</span>;
}
